import type { PlateElementProps } from "platejs/react";
import { PlateElement } from "platejs/react";
import { cn } from "@/lib/utils";

const headingStyles: Record<string, string> = {
	h1: "mb-1 mt-[1.6em] text-3xl font-bold",
	h2: "mb-1 mt-[1.4em] text-2xl font-semibold",
	h3: "mb-1 mt-[1.2em] text-xl font-semibold",
	h4: "mb-0.5 mt-[1em] text-lg font-semibold",
	h5: "mb-0.5 mt-[0.8em] text-base font-semibold",
	h6: "mb-0.5 mt-[0.8em] text-sm font-semibold uppercase tracking-wide text-muted-foreground",
};

export function HeadingElement({ children, className, element, ...props }: PlateElementProps) {
	const tag = element.type as string;
	const style = headingStyles[tag] || headingStyles.h1;

	return (
		<PlateElement {...props} element={element} as={tag as "h1"} className={cn(style, className)}>
			{children}
		</PlateElement>
	);
}
